import { Component, OnInit } from '@angular/core';
import { PagePath } from '../../../../shared/models/page-model';
import { QuestionnaireService } from '../../../../shared/services/questionnaire/questionnaire.service';
import { TrackingService } from '../../../../shared/services/tracking/tracking.service';
import { ProductConfigurationIds } from '../../../../shared/models/cart-model';
import { UtilityService } from '../../../../shared/services/utility.service';
import { CrossSellService } from '../../../../shared/services/cross-sell.service';
import { EventService } from '../../../../shared/services/event.service';

@Component({
  selector: 'app-desktop-lz-express-offers',
  templateUrl: './lz-express-offers.component.html',
  styleUrls: ['./lz-express-offers.component.scss']
})
export class LzExpressOffersComponent implements OnInit {
  public paidOrPaying: boolean;
  public packageSelected: string;
  itemList = [];

  constructor(
    public questionnaireService: QuestionnaireService,
    private trackingService: TrackingService,
    private utilityService: UtilityService,
    private crossSellService: CrossSellService,
    private eventService: EventService
  ) { }

  ngOnInit() {
    this.itemList = [{
      id: 'express-both',
      title: 'Will & Trademark Search',
      price: 148,
      usuallyPrice: 288,
      descriptionList: [
        'Protect your legacy with a will.',
        'Kickstart the trademark process with a federal trademark search.',
        `Save $140 off our usual price. One time only.`,
      ],
    }, {
      id: 'express-tms',
      title: 'Start a Trademark Search',
      price: 99,
      usuallyPrice: 199,
      descriptionList: [
        'As you launch your LLC, conducting a federal trademark search is the first step in protecting your business name as a brand.',
        'Our comprehensive trademark search report sorts and ranks results to make it easier to review and understand.',
        `Check if ${ this.questionnaireService.llc.entityName || 'your business name' } is available as a federal trademark.`,
      ],
    }, {
      id: 'express-lwt',
      title: 'Make a Will',
      price: 49,
      usuallyPrice: 89,
      descriptionList: [
        'Your business is an asset. Make sure your family or partner inherits it by creating a will.',
        'Your business (and your family) will thank you for not procrastinating.',
        '$40 off our regular price. Only for new LLC customers.',
      ],
    }];

    this.utilityService.requestIsUSCustomer().subscribe();
    this.trackingService.SetGA_Arrays(PagePath.ExpressOffersPage);
    this.crossSellService.newSkuArray = [];
  }

  onClickItem(id: string){
    this.packageSelected = this.packageSelected === id ? '' : id;
  }

  checkout(): void {
    this.paidOrPaying = true;
    this.crossSellService.newSkuArray = [];
    switch (this.packageSelected) {
      case 'express-lwt': {
        this.crossSellService.newSkuArray.push({
          sProductID: ProductConfigurationIds.lwtCrosssell,
          sProductName: 'Last Will and Testament',
          sRelationshipType: 'CrossSell'
        });
        break;
      }
      case 'express-tms': {
        this.crossSellService.newSkuArray.push({
          sProductID: ProductConfigurationIds.tmsCrosssell,
          sProductName: 'Trademark Search',
          sRelationshipType: 'CrossSell'
        });
        break;
      }
      case 'express-both': {
        this.crossSellService.newSkuArray.push({
          sProductID: ProductConfigurationIds.lwtCrosssell,
          sProductName: 'Last Will and Testament',
          sRelationshipType: 'CrossSell'
        });
        this.crossSellService.newSkuArray.push({
          sProductID: ProductConfigurationIds.tmsCrosssell,
          sProductName: 'Trademark Search',
          sRelationshipType: 'CrossSell'
        });
        break;
      }
      default: {
        this.paidOrPaying = false;
        break;
      }
    }
    this.crossSellService.savePackage(this.packageSelected);
  }

  continue(): void {
    const win = this.trackingService.winRef.nativeWindow;
    if (win.oCMOrder !== undefined) {
      this.trackingService.ClearOAItems();
      win.oCMOrder.oaItems = win.oCMOrder.oaItems.concat(this.crossSellService.newSkuArray);
    }
    this.eventService.saveAndContinue(PagePath.ExpressOffersPage);
  }

}
